export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'zh', label: '中文' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'ar', label: 'العربية' },
  { code: 'bn', label: 'বাংলা' },
  { code: 'pt', label: 'Português' },
  { code: 'ru', label: 'Русский' },
  { code: 'ur', label: 'اردو' },
];

const en = {
  language: 'Language',
  live: 'Live',
  connecting: 'Connecting',
  reconnecting: 'Reconnecting',
  offline: 'Offline',
  loading: 'Loading...',
  no_data: 'No data',
  nothing_to_display: 'Nothing to display',
  india: 'India',
  us: 'US',
  standings: 'Standings',
  games: 'Games',
  upcoming: 'Upcoming',
  finished: 'Finished',
  loading_events: 'Loading events...',
  retry: 'Retry',
  no_live_events: 'No live events',
  no_events: 'No {status} events',
  check_back: 'Check back soon or try another tab.',
  elite: 'Elite',
  round: 'Round',
  full_standings_games: 'Full standings & games',
  not_started_yet: 'Not started yet',
  no_standings_data: 'No standings data',
  loading_games: 'Loading games...',
  no_games_available: 'No games available.',
  tbd: 'TBD',
  white: 'White',
  black: 'Black',
  vs: 'vs',
  result: 'Result',
  prediction: 'Prediction',
  stockfish: 'Stockfish',
  start: 'Start',
  prev: 'Prev',
  play: 'Play',
  pause: 'Pause',
  next: 'Next',
  end: 'End',
  move: 'Move',
  moves_not_available: 'Moves not available for this game.',
  tournament: 'Tournament',
  opening: 'Opening',
  eco: 'ECO',
  all_events: 'All events',
  tournament_not_found: 'Tournament not found',
  back_to_events: 'Back to events',
  rounds: 'Rounds',
  rating: 'Rating',
  select_round_to_see_games: 'Select a round to see games',
  no_round_data: 'No round data available',
  could_not_load_round_games: 'Could not load games for this round.',
  no_games_found: 'No games found',
  loading_tournaments: 'Loading tournaments...',
  no_tournaments_available: 'No tournaments available right now.',
  location_unavailable: 'Location unavailable',
  status: 'Status',
  unknown: 'unknown',
  home: 'Home',
};

export const TRANSLATIONS = {
  en,
  zh: { ...en, language: '语言', live: '直播', connecting: '连接中', reconnecting: '重新连接中', offline: '离线', standings: '排名', games: '对局', upcoming: '即将开始', finished: '已结束', retry: '重试', no_live_events: '暂无直播赛事', no_games_available: '暂无对局', no_games_found: '未找到对局' },
  hi: { ...en, language: 'भाषा', live: 'लाइव', connecting: 'कनेक्ट हो रहा है', reconnecting: 'फिर से कनेक्ट हो रहा है', offline: 'ऑफलाइन', standings: 'स्टैंडिंग', games: 'गेम्स', upcoming: 'आगामी', finished: 'समाप्त', retry: 'पुनः प्रयास करें', no_live_events: 'कोई लाइव इवेंट नहीं', no_games_available: 'कोई गेम उपलब्ध नहीं', no_games_found: 'कोई गेम नहीं मिला' },
  es: { ...en, language: 'Idioma', live: 'En vivo', connecting: 'Conectando', reconnecting: 'Reconectando', offline: 'Sin conexión', standings: 'Clasificación', games: 'Partidas', upcoming: 'Próximamente', finished: 'Finalizado', retry: 'Reintentar', no_live_events: 'No hay eventos en vivo', no_games_available: 'No hay partidas disponibles', no_games_found: 'No se encontraron partidas' },
  fr: { ...en, language: 'Langue', live: 'En direct', connecting: 'Connexion', reconnecting: 'Reconnexion', offline: 'Hors ligne', standings: 'Classement', games: 'Parties', upcoming: 'À venir', finished: 'Terminé', retry: 'Réessayer', no_live_events: 'Aucun événement en direct', no_games_available: 'Aucune partie disponible', no_games_found: 'Aucune partie trouvée' },
  ar: { ...en, language: 'اللغة', live: 'مباشر', connecting: 'جارٍ الاتصال', reconnecting: 'إعادة الاتصال', offline: 'غير متصل', standings: 'الترتيب', games: 'المباريات', upcoming: 'قادم', finished: 'انتهى', retry: 'إعادة المحاولة', no_live_events: 'لا توجد فعاليات مباشرة', no_games_available: 'لا توجد مباريات', no_games_found: 'لا توجد مباريات' },
  bn: { ...en, language: 'ভাষা', live: 'লাইভ', connecting: 'সংযোগ হচ্ছে', reconnecting: 'পুনঃসংযোগ হচ্ছে', offline: 'অফলাইন', standings: 'স্ট্যান্ডিংস', games: 'গেমস', upcoming: 'আসন্ন', finished: 'শেষ', retry: 'আবার চেষ্টা করুন', no_live_events: 'কোনো লাইভ ইভেন্ট নেই', no_games_available: 'কোনো গেম নেই', no_games_found: 'কোনো গেম পাওয়া যায়নি' },
  pt: { ...en, language: 'Idioma', live: 'Ao vivo', connecting: 'Conectando', reconnecting: 'Reconectando', offline: 'Offline', standings: 'Classificação', games: 'Jogos', upcoming: 'Em breve', finished: 'Finalizado', retry: 'Tentar novamente', no_live_events: 'Sem eventos ao vivo', no_games_available: 'Nenhum jogo disponível', no_games_found: 'Nenhum jogo encontrado' },
  ru: { ...en, language: 'Язык', live: 'В эфире', connecting: 'Подключение', reconnecting: 'Переподключение', offline: 'Не в сети', standings: 'Таблица', games: 'Партии', upcoming: 'Скоро', finished: 'Завершено', retry: 'Повторить', no_live_events: 'Нет live-событий', no_games_available: 'Нет доступных партий', no_games_found: 'Партии не найдены' },
  ur: { ...en, language: 'زبان', live: 'لائیو', connecting: 'کنیکٹ ہو رہا ہے', reconnecting: 'دوبارہ کنیکٹ ہو رہا ہے', offline: 'آف لائن', standings: 'اسٹینڈنگز', games: 'گیمز', upcoming: 'آنے والا', finished: 'ختم', retry: 'دوبارہ کوشش کریں', no_live_events: 'کوئی لائیو ایونٹ نہیں', no_games_available: 'کوئی گیم دستیاب نہیں', no_games_found: 'کوئی گیم نہیں ملا' },
};
